const ROOT = 'RATE_SIMULATOR_';

const actions = {
  FETCH_OPTIONS_REQUEST: `${ROOT}FETCH_OPTIONS_REQUEST`,
  FETCH_OPTIONS_SUCCESS: `${ROOT}FETCH_OPTIONS_SUCCESS`,
  FETCH_OPTIONS_ERROR: `${ROOT}FETCH_OPTIONS_ERROR`,
  CLEAR_LIST_OPTIONS: `${ROOT}CLEAR_LIST_OPTIONS`,
  FETCH_FORM_DATA_REQUEST: `${ROOT}FETCH_FORM_DATA_REQUEST`,
  FETCH_FORM_DATA_SUCCESS: `${ROOT}FETCH_FORM_DATA_SUCCESS`,
  FETCH_FORM_DATA_ERROR: `${ROOT}FETCH_FORM_DATA_ERROR`,
  RUN_REQUEST: `${ROOT}RUN_REQUEST`,
  RUN_SUCCESS: `${ROOT}RUN_SUCCESS`,
  RUN_ERROR: `${ROOT}RUN_ERROR`,
  MARK_RESULT_STALE: `${ROOT}MARK_RESULT_STALE`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
